import { z } from 'zod';
import { EMAIL_REGEX } from '@app/constants/regex';
import { validatePhoneWithCountryCode } from '@app/utils/transformPhoneNumber';

export const quickEstimateContactSchema = z
  .object({
    email: z.string().trim().optional().default(''),
    phone: z.string().trim().optional().default(''),
  })
  .refine((data) => !!data.email || !!data.phone, {
    message: 'Please provide an email or phone number so we can contact you.',
    path: ['_form'],
  })
  .superRefine((data, ctx) => {
    if (data.email && data.email.length > 255) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please limit your input to 255 characters.',
        path: ['email'],
      });
    } else if (data.email && !EMAIL_REGEX.test(data.email)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid email address',
        path: ['email'],
      });
    }
    if (data.phone && data.phone.length > 32) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please limit your input to 32 characters.',
        path: ['phone'],
      });
    } else if (data.phone && !validatePhoneWithCountryCode(data.phone.replace(/[\s()\-]/g, ''))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid phone number. Must be 10 digits or include +1 followed by 10 digits.',
        path: ['phone'],
      });
    }
  });

export type QuickEstimateContactValues = {
  email: string;
  phone: string;
};
